/** Normalize Vuetify 3 validate() result (boolean or { valid }). */
export async function validateVuetifyForm(formRef) {
  if (!formRef?.value?.validate) {
    return { valid: false, errors: [] }
  }
  const result = await formRef.value.validate()
  if (typeof result === 'boolean') {
    return { valid: result, errors: [] }
  }
  return {
    valid: Boolean(result?.valid),
    errors: result?.errors || [],
  }
}

export function apiErrorMessage(err, fallback = 'Request failed') {
  const detail = err?.response?.data?.detail
  if (typeof detail === 'string') return detail
  if (detail?.message) return detail.message
  if (Array.isArray(detail)) {
    return detail.map((item) => item.msg || item.message || String(item)).join(', ')
  }
  return err?.message || fallback
}
